'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.init = undefined;

var _bindings = require('./bindings');

var init = exports.init = function init() {
	(0, _bindings.bindActions)();
};

$(document).ready(function () {

	var $sliderContainer = $('.index-hero__slider-container');

	if (!$sliderContainer.length) return;

	$sliderContainer.slick({
		infinite: true,
		speed: 500,
		arrows: false,
		fade: true,
		dots: true,
		lazyLoad: 'ondemand',
		mobileFirst: true,
		cssEase: 'linear',
		adaptiveHeight: true
	});
	$(window).resize(function () {
		$sliderContainer[0].slick.refresh();
	});
});